export default __webpack_public_path__ + "static/media/backrest30-demo.e54ea6c4.png";